// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Modal_wrap__pKzPF","content":"Modal_content__b1ltt"};